import { mockEvents } from '../data/mockEvents';
import { fetchWithAuth } from './authService';
import { throwApiError } from './apiError';

const USE_MOCK = false;

export const getEvents = async (historyId) => {
  if (USE_MOCK) return mockEvents;
  if (!historyId) return [];

  const hasToken = localStorage.getItem("access_token");

  const response = hasToken
    ? await fetchWithAuth(`/api/v2/histories/${historyId}/events`)
    : await fetch(`/api/v2/histories/${historyId}/events`);

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
};

export const createEvent = async (event, image, historyId) => {
  const formData = new FormData();
  formData.append('event', JSON.stringify(event));
  if (image) formData.append('image', image);

  const response = await fetchWithAuth(`/api/histories/${historyId}/events`, {
    method: 'POST',
    body: formData,
  });

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
}

export const deleteEvent = async (eventId) => {
  const response = await fetchWithAuth(`/api/events/${eventId}`, {
    method: 'DELETE',
  });

  if (response && response.ok) {
    if (response.status === 204 || response.status === 200) {
      return;
    }
    return await response.json();
  }

  await throwApiError(response);
}

export const updateEvent = async (eventId, eventData) => {
  const response = await fetchWithAuth(`/api/events/${eventId}`, {
    method: 'PATCH',
    body: JSON.stringify(eventData),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
};

export const updateEventImage = async (eventId, image) => {
  const formData = new FormData();
  formData.append('image', image);

  const response = await fetchWithAuth(`/api/events/${eventId}/image`, {
    method: 'PATCH',
    body: formData,
  });

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
}

export const deleteEventImage = async (eventId) => {
  const response = await fetchWithAuth(`/api/events/${eventId}/image`, {
    method: 'DELETE',
  });

  if (response && response.ok) {
    if (response.status === 204 || response.status === 200) {
      return;
    }
    return await response.json();
  }

  await throwApiError(response);
}